import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const ContactRowSkeleton = () => (
  <div className="spc-row" aria-hidden>
    <div className="spc-row-checkbox">
      <Skeleton variant="rect" width="1.1rem" height="1.1rem" />
    </div>
    <div className="spc-row-identity">
      <div className="spc-row-name">
        <Skeleton variant="text" width="9rem" />
      </div>
      <div className="spc-row-email">
        <Skeleton variant="text" width="12rem" />
      </div>
      <div className="spc-row-allow-email-change">
        <Skeleton variant="rect" width="9rem" height="1.4rem" />
      </div>
    </div>
    <div className="spc-row-roles">
      <Skeleton variant="rect" width="5rem" height="1.4rem" />
    </div>
    <div className="spc-row-properties">
      <Skeleton variant="text" width="6rem" />
    </div>
  </div>
);

export default ContactRowSkeleton;
